<div class="chat-container" id="chat-m-container">
  <form (ngSubmit)="filterMessages()" [formGroup]="filter" novalidate="novalidate" class="chat__filter form--soft">
    <div class="input-group">
      <a (click)="closeFilter()" class="chat-header__button" *ngIf="filterOn">
        <i class="ico-close"></i>
      </a>
      <app-date-time-picker id="from" class="chatDateFrom"
                            [controlName]="'dateFrom'"
                            [form]="filter"
                            [pickerType]="'DATE'"
                            [placement]="'bottom'"
                            [requiresSmallInput]="false"
                            [placeHolder]="'chat.messages.dateFrom' | translate"
                            (datePicked)="filterMessages()">
      </app-date-time-picker>
      <app-date-time-picker id="till" class="chatDateTill"
                            [controlName]="'dateTill'"
                            [form]="filter"
                            [pickerType]="'DATE'"
                            [placement]="'bottom-right'"
                            [requiresSmallInput]="false"
                            [placeHolder]="'chat.messages.dateTill' | translate"
                            (datePicked)="filterMessages()">
      </app-date-time-picker>
      <input type="text" name="textSearch" id="textSearch"
             formControlName="textSearch"
             class="form-control chatTextSearch"
             appAutocompleteOff />
      <button class="chat-header__button" role="button" type="submit">
        <i class="ico-search"></i>
      </button>
      <button class="chat-header__button datePicker" (click)="expandInput()">
        <i class="ico-calendar"></i>
      </button>
      <div class="files-filter">
        <input type="checkbox"
               class="graphic-control"
               id="hideAttachments"
               [checked]="hideMessagesWithFiles"
               (click)="applyFilesFilter($event.target.checked)">
        <label for="hideAttachments"
               title="{{'chat.messages.files-filter' | translate}}">
        </label>
      </div>
    </div>
  </form>

  <div class="chat__content filter-results message-list"
       *ngIf="filterOn"
       [ngClass]="{'results-visible': filterOn}"
       infinite-scroll
       [infiniteScrollUpDistance]="scrollUpDistance"
       [infiniteScrollDistance]="scrollDownDistance"
       [infiniteScrollThrottle]="throttle"
       [scrollWindow]="false"
       (scrolled)="loadMoreFilterMessages()">
    <div class="no-results" *ngIf="messagesToShow.length === 0">{{"chat.messages.no-messages" | translate}}</div>
    <div *ngFor="let message of messagesToShow" class="message">
      <ng-template #sender>
        <div class="d-flex flex-column">
          <span>{{ message.sender }}</span>
          <span>{{ message.senderPhoneNumber }}</span>
        </div>
      </ng-template>
      <div class="message-container" [ngClass]="{'message-container--driver': message.senderType == 'DRIVER', 'message-container--manager': message.senderType == 'MANAGER'}">
        <div class="msg__user-type">
          <i class="chat-user-img"
             [ngbTooltip]="sender"
             [ngClass]="{'ico-wheel': message.senderType == 'DRIVER',
                         'ico-user': message.senderType == 'MANAGER'}"></i>
        </div>
        <div class="message-body init-message filtered-message" (click)="findAndScrollTo(message.id, message.sentOn)">
          <div class="msg__heading">
            <div class="msg__user-info">
              <h6 class="msg__user-name">
                {{message.sender}}
              </h6>
              <p class="msg__user-phone">
                {{message.senderPhoneNumber}}
              </p>
            </div>
          </div>
          <div class="message-text" [ngClass]="{'message-text--translated': message.translation}">
            <div class="message-text__text">
              <div *ngIf="message.fileType" class="message-text__file" [ngClass]="{'message-text__text--original': message.translation}">
                <i class="ico-paperclip" *ngIf="message.fileType === MessageFileType.DOCUMENT"></i>
                <i class="ico-mic" *ngIf="message.fileType === MessageFileType.VOICE_MESSAGE"></i>
                <i class="ico-play" *ngIf="message.fileType === MessageFileType.VIDEO"></i>
                <span>{{message.fileType === MessageFileType.VOICE_MESSAGE ? getTranscription(message) : message.messageText}}</span>
              </div>
              <pre *ngIf="!message.fileType" [ngClass]="{'message-text__text--original': message.translation}">
                {{message.messageText}}
              </pre>
              <pre *ngIf="message.translation" class="message-text__text--translation">
                {{message.translation}}
              </pre>
            </div>
            <div class="message-text__action">
              <a class="icon-action"
                 *ngIf="message.file != '' && (isPicture(message) || message.fileType === MessageFileType.VOICE_MESSAGE
                 || message.fileType === MessageFileType.VIDEO)"
                 (click)="showFile(message, $event)"
                 [ngClass]="{'icon-action--active': showingFile === message.id}">
                <i [ngClass]="message.fileType === MessageFileType.VOICE_MESSAGE || message.fileType === MessageFileType.VIDEO
                              ? 'ico-play'
                              : 'ico-image'"></i>
              </a>
              <span class="icon-action"
                    *ngIf="isTranslationActive && message.senderType === 'DRIVER'
                           && message.fileType !== MessageFileType.VIDEO && hasTranslatableText(message)"
                    (click)="onTranslateAction(message)"
                    [ngbTooltip]="'chat.messages.translate' | translate"
                    [ngClass]="{'icon-action--active': message.translation}">
                <i class="ico-translate"></i>
              </span>
              <span class="icon-action"
                    *ngIf="message.file != '' && message.fileType === MessageFileType.VIDEO"
                    (click)="downloadFile(message.vehicleId, message.fileId); $event.stopPropagation()">
                <i class="ico-download"></i>
              </span>
            </div>
          </div>
          <ng-container *ngIf="showingFile === message.id">
            <img id="image-{{message.id}}"
                 class="scan-doc collapse"
                 src="{{fileUri + message.file}}"
                 *ngIf="message.file != '' && isPicture(message)"
                 (click)="showModal(message.id)">
            <div class="collapse" id="image-{{message.id}}" *ngIf="message.fileType === MessageFileType.VOICE_MESSAGE">
              <audio controls>
                <source src="{{fileUri + message.file}}" type="audio/mpeg">
                <source src="{{fileUri + message.file}}" type="audio/wav">
                <source src="{{fileUri + message.file}}" type="audio/ogg">
              </audio>
            </div>
            <div class="collapse" id="image-{{message.id}}" *ngIf="message.fileType === MessageFileType.VIDEO">
              <video controls preload="metadata">
                <source src="{{fileUri + message.file}}" type="video/mp4">
              </video>
            </div>
            <app-picture-modal *ngIf="modalVisible === message.id"
                               (close)="closeModal()"
                               (download)="downloadFile(message.vehicleId, message.fileId)"
                               (downloadAsPdf)="downloadPictureAsPdf(message.vehicleId, message.file, message.fileId)"
                               [isPDFDownloadVisible]="true"
                               [fileUri]="fileUri"
                               [content]="message.file"
                               [caption]="message.messageText">
            </app-picture-modal>
          </ng-container>
          <div class="messages-info" *ngIf="message.sentOn != null">
            <div class="messages-info__item"
                 [ngbTooltip]="('chat.messages.sentOn' | translate ) + ' ' + ( message.sentOn | date: 'yyyy-MM-dd HH:mm')">
              <i class="ico-send"></i>
              <span>{{message.sentOn | date: 'yyyy-MM-dd HH:mm'}}</span>
            </div>
            <div class="messages-info__item"
                 *ngIf="message.receivedOn != null"
                 [ngbTooltip]="('chat.messages.receivedOn' | translate ) + ' ' + ( message.receivedOn | date: 'yyyy-MM-dd HH:mm')">
              <i class="ico-mail"></i>
              <span>{{message.receivedOn | date: 'yyyy-MM-dd HH:mm'}}</span>
            </div>
            <div class="messages-info__item"
                 *ngIf="didEmployeeSaw(message) && message.senderType == 'DRIVER'"
                 [ngbTooltip]="('chat.messages.seen' | translate ) + ' ' + ( getSeenOn(message) | date: 'yyyy-MM-dd HH:mm')">
              <i class="ico-mail-open"></i>
              <span>{{getSeenOn(message) | date: 'yyyy-MM-dd HH:mm'}}</span>
            </div>
            <div class="messages-info__item"
                 *ngIf="message.openedOn != null && message.senderType == 'MANAGER'"
                 [ngbTooltip]="('chat.messages.seen' | translate ) + ' ' + ( message.openedOn | date:'yyyy-MM-dd HH:mm')">
              <i class="ico-mail-open"></i>
              <span>{{message.openedOn | date: 'yyyy-MM-dd HH:mm'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="chat__content message-list" id="message-m-list"
       [ngClass]="{'message-list--file': file}"
       infinite-scroll
       [infiniteScrollUpDistance]="scrollUpDistance"
       [infiniteScrollDistance]="scrollDownDistance"
       [infiniteScrollThrottle]="throttle"
       [scrollWindow]="false"
       (scrolledUp)="getMessages()"
       (scrolled)="addMessages()">

    <div *ngFor="let message of messagesToShow" class="message">
      <ng-template #sender>
        <div class="d-flex flex-column">
          <span>{{ message.sender }}</span>
          <span>{{ message.senderPhoneNumber }}</span>
        </div>
      </ng-template>

      <span *ngIf="lastReadMessageId && message.id === lastReadMessageId" class="last-message-divider">
        {{'chat.messages.new-messages' | translate}}
      </span>
      <div class="message-container" [ngClass]="{'message-container--driver': message.senderType == 'DRIVER', 'message-container--manager': message.senderType == 'MANAGER'}">
        <div class="msg__user-type">
          <i *ngIf="message.drawNewBox"
             class="chat-user-img"
             [ngbTooltip]="sender"
             [ngClass]="{'ico-wheel': message.senderType == 'DRIVER',
                         'ico-user': message.senderType == 'MANAGER'}"></i>
        </div>
        <div class="message-body"
             [ngClass]="{'init-message': message.drawNewBox, 'loaded-message': message.id === filteredMessage}"
             id="message-{{message.id}}">
          <div class="msg__heading" *ngIf="message.drawNewBox">
            <div class="msg__user-info">
              <h6 class="msg__user-name">
                {{message.sender}}
              </h6>
              <p class="msg__user-phone">
                {{message.senderPhoneNumber}}
              </p>
            </div>
            <div id="readBy-{{message.id}}" class="read-by" *ngIf="message.senderType == 'DRIVER'">
              <i class="cursor-pointer ico-eye"
                 *ngIf="message.employeeRead.length > 0"
                 [ngbTooltip]="getReadTooltip(message.employeeRead)">
              </i>
              <span *ngIf="didEmployeeSaw(message)">{{getEmployeeName(message)}}</span>
              <button *ngIf="didEmployeeSaw(message)"
                 class="msg__mark-as-unread"
                 (click)="markAsUnread(message)"
                 [ngbTooltip]="'chat.messages.markAsUnread' | translate"><i class="ico-mail"></i></button>
            </div>
          </div>
          <div class="message-text" [ngClass]="{'message-text--translated': message.translation}">
            <div class="message-text__text">
              <div *ngIf="message.fileType" class="message-text__file" [ngClass]="{'message-text__text--original': message.translation}">
                <i class="ico-paperclip" *ngIf="message.fileType === MessageFileType.DOCUMENT"></i>
                <i class="ico-mic" *ngIf="message.fileType === MessageFileType.VOICE_MESSAGE"></i>
                <i class="ico-play" *ngIf="message.fileType === MessageFileType.VIDEO"></i>
                <span>{{message.fileType === MessageFileType.VOICE_MESSAGE ? getTranscription(message) : message.messageText}}</span>
              </div>
              <pre *ngIf="!message.fileType" [ngClass]="{'message-text__text--original': message.translation}">
                {{message.messageText}}
              </pre>
              <pre *ngIf="message.translation" class="message-text__text--translation">
                {{message.translation}}
              </pre>
            </div>
            <div class="message-text__action">
              <a class="icon-action"
                 *ngIf="message.file != '' && (isPicture(message) || message.fileType === MessageFileType.VOICE_MESSAGE
                 || message.fileType === MessageFileType.VIDEO)"
                 [ngClass]="{'icon-action--active': showingFile === message.id}"
                 tabindex="2"
                 (click)="showFile(message, $event)">
                <i [ngClass]="message.fileType === MessageFileType.VOICE_MESSAGE || message.fileType === MessageFileType.VIDEO
                              ? 'ico-play'
                              : 'ico-image'">
                </i>
              </a>
              <span class="icon-action"
                    *ngIf="isTranslationActive && message.senderType === 'DRIVER' && !isPicture(message)
                           && message.fileType !== MessageFileType.VIDEO && hasTranslatableText(message)"
                    (click)="onTranslateAction(message)"
                    [ngbTooltip]="'chat.messages.translate' | translate"
                    [ngClass]="{'icon-action--active': message.translation}">
                <i class="ico-translate"></i>
              </span>
              <span class="icon-action"
                    *ngIf="message.file != '' && !isPicture(message)
                           && (message.senderType == 'MANAGER' || message.fileType === MessageFileType.VIDEO)"
                    (click)="downloadFile(message.vehicleId, message.fileId)">
                <i class="ico-download"></i>
              </span>
            </div>
          </div>
          <div class="message-text__media" *ngIf="showingFile === message.id">
            <ng-container [ngSwitch]="message.fileType">
              <ng-container *ngSwitchCase="MessageFileType.DOCUMENT">
                <img id="image-{{message.id}}"
                     class="scan-doc collapse"
                     src="{{fileUri + message.file}}"
                     *ngIf="message.file != '' && isPicture(message)"
                     (click)="showModal(message.id)">
                <app-picture-modal *ngIf="modalVisible === message.id"
                                   (close)="closeModal()"
                                   (download)="downloadFile(message.vehicleId, message.fileId)"
                                   (downloadAsPdf)="downloadPictureAsPdf(message.vehicleId, message.file, message.fileId)"
                                   [isPDFDownloadVisible]="true"
                                   [fileUri]="fileUri"
                                   [content]="message.file"
                                   [caption]="message.messageText">
                </app-picture-modal>
              </ng-container>
              <ng-container *ngSwitchCase="MessageFileType.VOICE_MESSAGE">
                <div class="collapse" id="image-{{message.id}}">
                  <audio controls>
                    <source src="{{fileUri + message.file}}" type="audio/mpeg">
                    <source src="{{fileUri + message.file}}" type="audio/wav">
                    <source src="{{fileUri + message.file}}" type="audio/ogg">
                  </audio>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="MessageFileType.VIDEO">
                <div class="collapse" id="image-{{message.id}}">
                  <video controls preload="metadata">
                    <source src="{{fileUri + message.file}}" type="video/mp4">
                  </video>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="messages-info">
            <div class="messages-info__item"
                 *ngIf="message.sentOn != null"
                 [ngbTooltip]="('chat.messages.sentOn' | translate ) + ' ' + ( message.sentOn | date: 'yyyy-MM-dd HH:mm')">
              <i class="ico-send"></i>
              <span>{{message.sentOn | date: 'yyyy-MM-dd HH:mm'}}</span>
            </div>
            <div class="messages-info__item"
                 *ngIf="message.receivedOn != null"
                 [ngbTooltip]="('chat.messages.receivedOn' | translate ) + ' ' + ( message.receivedOn | date: 'yyyy-MM-dd HH:mm')">
              <i class="ico-mail"></i>
              <span>{{ message.receivedOn | date: 'yyyy-MM-dd HH:mm'}}</span>
            </div>
            <div class="messages-info__item"
                 *ngIf="didEmployeeSaw(message) && message.senderType == 'DRIVER'"
                 [ngbTooltip]="('chat.messages.seen' | translate ) + ' ' + ( getSeenOn(message) | date: 'yyyy-MM-dd HH:mm')">
              <i class="ico-mail-open"></i>
              <span>{{ getSeenOn(message) | date: 'yyyy-MM-dd HH:mm'}}</span>
            </div>
            <div class="messages-info__item"
                 *ngIf="message.openedOn != null && message.senderType == 'MANAGER'"
                 [ngbTooltip]="(message.id === lastSeenMessage
                                ? ('chat.messages.seenByDriver' | translate)
                                : ('chat.messages.seen' | translate))
                                + ' ' +
                                (message.openedOn | date:'yyyy-MM-dd HH:mm')">
              <i class="ico-mail-open" *ngIf="message.id != lastSeenMessage"></i>
              <i class="ico-eye" *ngIf="message.id == lastSeenMessage"></i>
              <span>
                {{ message.openedOn | date: 'yyyy-MM-dd HH:mm'}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isTabOffline()" class="alert alert-danger">
      <i class="ico-tablet-off sz-m mr-1 align-middle"></i> <strong>{{'chat.messages.warning' | translate}}</strong>
      {{'chat.messages.tab-offline' | translate}}
    </div>
    <div *ngIf="inSwitzerland" class="alert alert-info switz" (click)="flushFiles()">
      <i class="ico-download"></i>
      <span class="ml-2">{{'chat.messages.switzerland' | translate}}</span>
    </div>
  </div>

  <div class="chat__input form--soft">
    <div class="chat-templates" *ngIf="messagesTemplatesVisible" id="chat-m-templates">
      <div *ngFor="let message of messagesTemplates"
           class="chat-templates__message"
           (click)="setMessage(message)">
         <span>{{message}}</span>
      </div>
      <div class="chat-templates__info--empty" *ngIf="messagesTemplates == null || messagesTemplates.length == 0">
        <small>{{'chat.messages.no-templates' | translate}}</small>
      </div>
      <div class="item__action--tertiary" (click)="navigateToSettings()">
        <i class="ico-plus"></i> {{'chat.messages.create-templates' | translate}}
      </div>
    </div>
    <div class="uploaded-file" id="upload-m-file">
      <i class="ico-paperclip" *ngIf="file"></i>
      <input type="text" value="{{file.name}}" *ngIf="file" appAutocompleteOff>
      <i class="ico-close delete-file" (click)="removeFile()" *ngIf="file"></i>
    </div>
    <div class="input-group chat-text" id="chat-m-text">
      <textarea type="text"
                class="form-control"
                rows="1"
                id="text-m-input"
                placeholder="{{'chat.messages.text' | translate}}"
                maxlength="10000"
                (paste)="onPaste($event)"
                (keydown.shift.enter)="onKeyShiftEnter($event)"
                (keydown.enter)="onKeyEnter($event)"
                [(ngModel)]="newChatText">
      </textarea>
      <div class="input__buttons" id="text-buttons">
        <a class="input__button templates-toggle"
           title="{{'chat.messages.templates' | translate}}"
           (click)="showMessagesTemplates()"
           [ngClass]="{'input__button--selected': this.messagesTemplatesVisible}"
           id="messages-templates">
          <i class="ico-list"></i>
        </a>
        <a class="input__button send" id="send-m-button"
           (click)="addChatItem()">
           <i class="ico-send"></i>
        </a>
        <div class="input__button ico-upload upload">
          <input id="upload"
                 class="file-upload-input"
                 type="file"
                 accept=".pdf,.txt,image/*,.xlsx,.xls"
                 (change)="fileChange(upload)"
                 #upload>
        </div>
      </div>
    </div>
  </div>
</div>
